import { StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  stepTitle: {
    fontSize: Fonts.size.h4,
    marginVertical: 15,
    ...Fonts.type.bold,
  },
  stepDesc: theme => ({
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorTwo,
    fontFamily: Fonts.type.VFFont,
    lineHeight: 18,
  }),
  offerCardStyle: {
    marginHorizontal: 0,
    marginTop: 20,
  },
  cardContentContainer: {
    paddingVertical: 0,
    borderWidth: 0,
  },
  cardStyle: {
    marginBottom: 30,
  },
  container: {
    paddingBottom: 20,
    paddingHorizontal: 16,
    //minHeight: 280,
  },
  simCardStyle: {
    marginTop: 20,
  },
  simCardContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    marginLeft: 10,
    flex: 1,
    justifyContent: 'space-evenly'
  },
  title: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: Fonts.size.h5,
    ...Fonts.type.bold,
  }),
  line: theme => ({
    marginVertical: 20,
    backgroundColor: theme.colors.borderColorThree,
  }),
  selectedSimContainer: theme => ({
    backgroundColor: theme.colors.backgroundColorTwo,
    padding: 15,
    borderRadius: 8,
    flexDirection: 'row',
  }),
  cardTitle: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h5,
  },
  deliveryContainer: theme => ({
    borderWidth: 2,
    borderColor: Colors.ocean,
    borderRadius: 8,
    flexDirection: 'row',
    marginVertical: 10,
    paddingHorizontal: 15,
    backgroundColor: theme.colors.cardBackgroundColor,
    alignItems: 'center',
    overflow: 'hidden',
  }),
  address: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: Fonts.size.h5,
    ...Fonts.type.bold,
    paddingLeft: 10,
    paddingRight: 25,
  }),
  addressContainer: {
    marginTop: 20,
  },
  titleOfferStyle: {
    ...Fonts.type.bold,
  },
  inputContainer: {
    flex: 1,
    height: 60,
    marginLeft: 10,
    justifyContent: 'center'
  }
})

export default styles
